module.exports = __webpack_public_path__ + "static/img/o4.aad3b2a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/owl/o4.jpg
// module id = wwDG
// module chunks = 0